import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const ProjectRegistration = lazy(() => import('../../container/borrower/project/ProjectRegistration'));
const ProjectList = lazy(() => import('../../container/borrower/project/projectList'));
const ProjectUpdate = lazy(() => import('../../container/borrower/project/projectUpdate'));
const ProjectDetails = lazy(() => import('../../container/borrower/project/projectDetail/projectDetails'));
const ProjectDocuments = lazy(() => import('../../container/borrower/project/ProjectDocuments'));
const ProjectMilestones = lazy(() => import('../../container/borrower/project/ProjectMilestones'));
const MilestoneDetails = lazy(() => import('../../container/borrower/project/MilestoneDetails'));

function ProjectRoute() {
  return (
    <Routes>
      <Route path="registration" element={<ProjectRegistration />} />
      <Route path="list" element={<ProjectList />} />
      <Route path="/update/:id" element={<ProjectUpdate />} />
      <Route path="detail/:id" element={<ProjectDetails />} />
      <Route path="/:id/documents" element={<ProjectDocuments />} />
      <Route path="/:id/milestones" element={<ProjectMilestones />} />
      <Route path="/milestones/:id" element={<MilestoneDetails />} />
    </Routes>
  );
}

export default ProjectRoute;
